<div class="container">
    <div class="flex-container">
        <ng-container>
            <div class="search-section">
                <h2 style="margin-bottom: 0">Widget List</h2>
                <div>
                    <app-table-search
                        [searchFunction]="onQuickFilterChanged.bind(this)"
                    ></app-table-search>
                </div>
            </div>
            <div class="filter-section">
                <div class="filter-row">
                    <div class="filter-label">
                        <h3>Filter & Search By:</h3>
                    </div>
                    <div class="filter-dropdown">
                        <app-multi-select-dropdown
                            *ngIf="cloudFilterInfo"
                            [filterInfo]="cloudFilterInfo"
                            [selectedValues]="cloudSelected"
                            (change)="
                                updateFilterInfoListData($event, CLOUD_KEY)
                            "
                        ></app-multi-select-dropdown>
                    </div>
                    <div class="filter-dropdown">
                        <app-multi-select-dropdown
                            *ngIf="productFilterInfo"
                            [filterInfo]="productFilterInfo"
                            [selectedValues]="productSelected"
                            (change)="
                                updateFilterInfoListData($event, PRODUCT_KEY)
                            "
                        ></app-multi-select-dropdown>
                    </div>
                    <div class="filter-dropdown">
                        <app-multi-select-dropdown
                            *ngIf="subProductFilterInfo"
                            [filterInfo]="subProductFilterInfo"
                            [selectedValues]="subProductSelected"
                            (change)="
                                updateFilterInfoListData(
                                    $event,
                                    SUB_PRODUCT_KEY
                                )
                            "
                        ></app-multi-select-dropdown>
                    </div>
                    <div class="filter-dropdown">
                        <app-multi-select-dropdown
                            *ngIf="serviceFilterInfo"
                            [filterInfo]="serviceFilterInfo"
                            [selectedValues]="serviceSelected"
                            (change)="
                                updateFilterInfoListData($event, SERVICE_KEY)
                            "
                        ></app-multi-select-dropdown>
                    </div>
                </div>
                <div class="filter-row bulk-row">
                    <div class="filter-label">
                        <h3>Bulk Update:</h3>
                    </div>
                    <div class="filter-dropdown">
                        <app-single-select-dropdown
                            *ngIf="permissionFilterInfo"
                            [filterInfo]="permissionFilterInfo"
                            [clearable]="true"
                            [selectedValue]="permissionSelected"
                            (change)="changePermissionOfAllWidgets($event)"
                        ></app-single-select-dropdown>
                    </div>
                </div>
            </div>
            <div class="table-section">
                <ng-container *ngIf="tableGenInput && aclApiInfo">
                    <app-only-table-generator
                        *ngIf="tableGenInput && aclApiInfo"
                        [tableInput]="tableGenInput"
                        [apiInfo]="aclApiInfo"
                        [defaultColDef]="defaultColDef"
                        [hideControlBar]="true"
                        [autoFitColumns]="false"
                        [useMaterialIcons]="true"
                        (gridRef)="gridRef = $event; gridSetInitialSelection()"
                        (selectionChange)="selectionChanged($event)"
                    ></app-only-table-generator>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="controls">
        <app-button-generator
            [buttonGenInput]="cancelButtonGenInput"
            (buttonRef)="modalService.closeModal(null, modalInputData.modalId)"
        ></app-button-generator>
        <app-button-generator
            *ngIf="gridRef && gridRef.rowData"
            [disabled]="
                gridRef && gridRef.api && !gridRef.api.getSelectedRows().length
            "
            [buttonGenInput]="insertButtonGenInput"
            (buttonRef)="insertWidgetsToModule()"
        ></app-button-generator>
    </div>
</div>
